import { StrictMode } from 'react';

import * as Sentry from '@sentry/react';

import { useCreditUpdates } from '@/shared/hooks/use-credit-updates';

import { DefaultMeta } from './components/default-meta';
import { GlobalModals } from './components/global-modals';
import { Providers } from './providers';
import { AppRouter } from './router';

const AppWithCreditUpdates = () => {
  useCreditUpdates();

  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div
          style={{
            padding: '40px',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
        >
          <h1 style={{ fontSize: '24px', marginBottom: '16px', color: '#ef4444' }}>
            Oops! Something went wrong
          </h1>
          <p style={{ marginBottom: '24px', color: '#6b7280' }}>
            An unexpected error occurred. We've been notified and will fix it soon.
          </p>
          <details
            style={{
              marginBottom: '24px',
              textAlign: 'left',
              maxWidth: '600px',
              margin: '0 auto 24px',
            }}
          >
            <summary style={{ cursor: 'pointer', marginBottom: '8px' }}>Error details</summary>
            <pre
              style={{
                background: '#f3f4f6',
                padding: '12px',
                borderRadius: '6px',
                fontSize: '12px',
                overflow: 'auto',
              }}
            >
              {(error as Error)?.message || 'Unknown error'}
            </pre>
          </details>
          <button
            onClick={resetError}
            style={{
              background: '#3b82f6',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Try again
          </button>
        </div>
      )}
      showDialog={true}
    >
      <DefaultMeta />
      <AppRouter />
      <GlobalModals />
      {/* <SentryTest /> */}
    </Sentry.ErrorBoundary>
  );
};

export const App = () => {
  return (
    <StrictMode>
      <Providers>
        <AppWithCreditUpdates />
      </Providers>
    </StrictMode>
  );
};
